import React, { useRef } from 'react';
import { PollsTabsOnMobile, PollsViewStatuses } from '../../../constans/polls-constants';
import PollEntity from '../../../store/polls-store/poll-entity';
import ActionEllipsis from '../../shared/action-ellipsis/action-ellipsis';
import PollEllipsisMenu from '../poll-ellipsis-menu/poll-ellipsis-menu';
import { observer } from 'mobx-react';

interface IProps {
  poll: PollEntity;
  isEllipsisMenuOpened: boolean;
  setShouldShowEllipsisMenu: (value: boolean) => void;
  setShouldShowDeleteModal: (value: boolean) => void;
  setShouldShowResetModal: (value: boolean) => void;
  toggleManagePollModal: () => void;
  changePollStatus: (poll: PollEntity, customStatus?: PollsViewStatuses) => Promise<void>;
  setActiveMobileTab: (tab: PollsTabsOnMobile) => void;
  isMobile: boolean;
  isOnePollOpened: boolean;
}

const ElipsisMenuWrapper: React.FC<IProps> = ({
  poll,
  isEllipsisMenuOpened,
  setShouldShowEllipsisMenu,
  setShouldShowDeleteModal,
  setShouldShowResetModal,
  toggleManagePollModal,
  changePollStatus,
  setActiveMobileTab,
  isMobile,
  isOnePollOpened
}) => {
  const forwardedRef = useRef(null);
  const shouldShowEllipsis = isEllipsisMenuOpened && forwardedRef.current;

  const toggleEllipsisMenu = (): void => {
    setShouldShowEllipsisMenu(!isEllipsisMenuOpened);
  };

  const reopenPollHandler = (): void => {
    changePollStatus(poll, PollsViewStatuses.IN_PROGRESS);
  };

  return (
    <div className='poll-item-ellipsis-wrapper'>
      <ActionEllipsis forwardedRef={forwardedRef} onClick={toggleEllipsisMenu}/>
      {shouldShowEllipsis &&
        <PollEllipsisMenu
          setShouldShowEllipsisMenu={setShouldShowEllipsisMenu}
          setShouldShowDeleteModal={setShouldShowDeleteModal}
          setShouldShowResetModal ={setShouldShowResetModal}
          reopenPollHandler={reopenPollHandler}
          toggleManagePollModal={toggleManagePollModal}
          setActiveMobileTab={setActiveMobileTab}
          forwardedRef={forwardedRef}
          pollStatus={poll.status}
          isClosingStatus={poll.shouldShowClosingProgress}
          isMobile={isMobile}
          isOnePollOpened={isOnePollOpened}
        />
      }
    </div>
  );
};

export default observer(ElipsisMenuWrapper);